export default "__VITE_ASSET__Ddh7RqQy__"